import { ProviderInstanceProfileCountryModel } from './provider-instance-profile-country-model';

export class ProfileCountryRebuildModel {
  providerInstances: ProviderInstanceProfileCountryModel[];
}
